import * as React from 'react';
import { IconButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ZefixConfig } from './zefix-config';
import axios from 'axios';

export interface SearchResultsItemProps {
    data: SearchResultItemData;
    index: number;
}

export interface SearchResultItemData {
    name: string;
    ehraid: string;
    uid: string;
    legalSeat: string;
    status: string;
    info: object;
    icon: string;
    chid: string;
}

export interface SearchResultsItemState {
    data: any;
    collapsed: boolean;
}

var statusToIconMap = {
    'EXISTIEREND': 'CircleFill',
    'GELOESCHT': 'CircleRing',
    'IN_AUFLOESUNG': 'CircleHalfFull'
}
var statusToTextMap = {
    'EXISTIEREND': 'Existierend',
    'GELOESCHT': 'Gelöscht',
    'IN_AUFLOESUNG': 'In Auflösung'
}

export class SearchResultsItem extends React.Component<SearchResultsItemProps, SearchResultsItemState> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            data: {

            },
            collapsed: true
        };
    }

    componentDidMount() {
        this.setState({
            collapsed: true
        });
    }

    clickInsert = async () => {

        await Word.run(async (context) => {
            var range = context.document.getSelection();
            range.insertText(`${this.props.data.name}\n${this.props.data.legalSeat}`, Word.InsertLocation.end);
            await context.sync();
        });

    }

    loadData = async () => {
        if(this.state.data.length > 0) {
            return
        }
        try {
          let response = await axios.get(`https://zefix.lexsear.ch/ZefixREST/api/v1/firm/${this.props.data.ehraid}`)
          response.data.uid = this.props.data.uid;
          response.data.chid = this.props.data.chid;
          this.setState({data: response.data});
        } catch (e) {
          document.body.innerHTML = e.message
        }
    }

    clickToggleCollapse = async () => {
        await this.loadData();
        this.setState({collapsed: !this.state.collapsed})

    }

    clickInsertForParty = async (partyPrefix) => {
        await Word.run(async (context) => {
            try {
                await this.loadData();
                this.state.data.address = `${this.state.data.address.street} ${this.state.data.address.houseNumber}\n${this.state.data.address.swissZipCode} ${this.state.data.address.town}`;
                var contentControls = context.document.contentControls;
                context.load(contentControls, 'id, text, tag, title, font/*');
                await context.sync();
                if (contentControls.items.length > 0) {
                    for (let entry of ['name', 'address', 'uid']) {
                        for (let contentControl of contentControls.items) {
                            if (contentControl.tag === `lexsearch_zefix_p${partyPrefix}${entry}` ) {
                                let originalFont = contentControl.font;
                                contentControl.insertText(`${this.state.data[entry]}`, Word.InsertLocation.replace);
                                contentControl.font.name = originalFont.name;
                                contentControl.font.size = originalFont.size;
                                contentControl.font.bold = originalFont.bold;
                                contentControl.font.italic = originalFont.italic;
                                contentControl.font.underline = originalFont.underline;
                                contentControl.font.strikeThrough = originalFont.strikeThrough;
                                contentControl.font.doubleStrikeThrough = originalFont.doubleStrikeThrough;
                                contentControl.font.color = originalFont.color;
                            }
                        }
                    }
                    await context.sync();
                }
            } catch(e) {
                console.warn(e)
            }
        });

    }

    render() {
        let registryOfficeLink = '';
        let registryOffice = this.state.data.registerOfficeId ? ZefixConfig.registryOffices[this.state.data.registerOfficeId] : {};
        if (this.state.data.registerOfficeId) {
            if (registryOffice.url2.indexOf('NNNNNNNNNNNNN') > -1) {
                registryOfficeLink = registryOffice.url2.replace('NNNNNNNNNNNNN', this.state.data.chid)
            } else {
                registryOfficeLink = registryOffice.url2.replace('#', this.state.data.uid)
            }
        }
        let address = this.state.data.address ? this.state.data.address : {};
        return (
           <div className='ms-ListBasicExample-itemCell-Wrapper' style={{borderTop: '1px solid #f4f4f4',  borderBottom: '1px solid #eaeaea'}}>
          <div className='ms-ListBasicExample-itemCell ms-bgColor-white' data-is-focusable={ true }>

             <div className='ms-Image ms-ListBasicExample-itemImage' style={{width: 50, height: 50}}>
                <i className={`ms-Icon ms-Icon--${this.props.data.icon}`}></i>
            </div>
            <div className='ms-ListBasicExample-itemContent'>
              <div className='ms-ListBasicExample-itemName'>{this.props.data.name}</div>
              <div className='ms-ListBasicExample-itemIndex'>
              <i style={{display: this.props.data.status === 'EXISTIEREND' ? 'none' : 'inline'}} className={`ms-Icon ms-Icon--${statusToIconMap[this.props.data.status]}`} title={ statusToTextMap[this.props.data.status] }>&nbsp;</i>
              { this.props.data.legalSeat } { this.props.data.uid }
              </div>
              <div style={{display: 'none'}} className='ms-ListBasicExample-itemDesc'>{ this.props.data.legalSeat }</div>
            </div>
            <IconButton
              menuIconProps={
                  {
                      iconName: 'Add',
                      style: {fontWeight: 'bold'}
                  }
              }
              className='ms-ListBasicExample-itemButtons'
              menuProps={ {
                  items: [
                      {
                          key: 'insert_party_a',
                          name: 'Insert for Party A',
                          icon: 'AddFriend',
                          onClick: () => this.clickInsertForParty('0')
                      }, {
                          key: 'insert_party_b',
                          name: 'Insert for Party B',
                          icon: 'AddFriend',
                          onClick: () => this.clickInsertForParty('1')
                      }, {
                          key: 'insert_party_c',
                          name: 'Insert for Party C',
                          icon: 'AddFriend',
                          onClick: () => this.clickInsertForParty('2')
                      }
                  ]
              }}
              />
            <IconButton
              menuIconProps={
                  {
                      iconName: !this.state.collapsed ? 'ChevronDown' : 'ChevronRight',
                      style: {fontWeight: 'bold'}
                  }
              }
              onClick={this.clickToggleCollapse}
              className='ms-ListBasicExample-itemButtons'
              />
          </div>
          <div style={{display: this.state.collapsed ? 'none' : 'block', paddingTop: 0}} className='ms-ListBasicExample-itemCell ms-bgColor-white' data-is-focusable={ true }>

              <div style={{flexBasis: '100%'}}>
                  <b>{address.organisation}</b><br />
                  {address.street} {address.houseNumber}<br />
                  {address.swissZipCode} {address.town}<br /><br />
                  <DefaultButton title={registryOffice.address1} text={registryOffice.shortDesc} href={registryOfficeLink} target='_blank' iconProps={{iconName: 'Share'}} />
              </div>
          </div>
          </div>
        );
    };
};



// WEBPACK FOOTER //
// ./components/search-results-item.tsx